import React from 'react'
import { motion } from 'framer-motion'
import s from './onboarding.module.scss'
import { Button } from '@shared/ui/button/button'
import { useNavigate } from 'react-router-dom'
import { useOnboardingPassed } from '@entities/profile/api/useOnboardingPassed'
import { IconCheck } from '@tabler/icons-react'
import { itemVariants, sectionVariants } from '@shared/lib/onboarding-motion'

export const RegistrationComplete = () => {
	const navigate = useNavigate()
	const {mutate, isPending} = useOnboardingPassed()

	const goToDashboard = () => {
		mutate({
			onboarding_passed: true
		}, {
			onSuccess: () => {
				navigate('/')
			}
		})
	}

	return (
		<motion.div className={s.slideWrapper} variants={sectionVariants} initial="initial" animate="animate">
			<motion.div className={s.completePanel} variants={sectionVariants}>
				<motion.div
					className={s.completeIcon}
					variants={itemVariants}
					initial={{ opacity: 0, scale: 0.7, rotate: -8 }}
					animate={{ opacity: 1, scale: 1, rotate: 0 }}
					transition={{ type: 'spring', stiffness: 360, damping: 22 }}
				>
					<IconCheck size={32} stroke={3} />
				</motion.div>
				<motion.div className={s.titleWrapper} variants={itemVariants}>
					<p className={s.title}>Отлично!</p>
					<p className={s.subtitle}>Мы все сохранили и уже подбираем идеального преподователя под твой запрос</p>
				</motion.div>
				<motion.div className={s.btns} variants={itemVariants}>
					<Button
						label="Перейти в личный кабинет"
						size="small"
						className={s.button}
						disabled={isPending}
						fetching={isPending}
						onClick={goToDashboard}
					/>
				</motion.div>
			</motion.div>
		</motion.div>
	)
}
